module.exports = __webpack_public_path__ + "img/2025-0327-02-02.1ead01de.png";